import React from "react";
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Avatar,
  Typography,
  CircularProgress,
  Alert,
  Button,
  useMediaQuery,
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import { Lock } from "lucide-react";
import { GlassDialog, dialogTransitionProps } from "../../../theme/theme";

export function OfflineKeyDialog({
  offlineKeyDialog,
  setOfflineKeyDialog,
  theme,
  darkMode,
  copiedField,
  handleCopy,
}) {
  const close = () => setOfflineKeyDialog({ open: false, key: "", license_id: "", warning: null, loading: false });
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <GlassDialog open={offlineKeyDialog.open} onClose={close} maxWidth="sm" fullWidth fullScreen={fullScreen} {...dialogTransitionProps}>
      <DialogTitle sx={{ pb: 1 }}>
        <Box display="flex" alignItems="center" gap={1.5}>
          <Avatar sx={{ bgcolor: alpha(theme.palette.secondary.main, 0.1), width: 48, height: 48 }}>
            <Lock color={theme.palette.secondary.main} />
          </Avatar>
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 700, color: darkMode ? "#EAF3FB" : "#0E1B2C" }}>
              Offline Activation Key
            </Typography>
            <Typography variant="caption" sx={{ color: darkMode ? "#93A2BC" : "text.secondary" }}>
              License: {offlineKeyDialog.license_id}
            </Typography>
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ pt: 3 }}>
        {offlineKeyDialog.loading ? (
          <Box display="flex" justifyContent="center" p={4}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            {offlineKeyDialog.warning && (
              <Alert severity="warning" sx={{ mb: 2 }}>
                {offlineKeyDialog.warning}
              </Alert>
            )}
            <Box
              onClick={() => handleCopy(offlineKeyDialog.key, "offline-key")}
              sx={{
                p: 2,
                bgcolor: darkMode ? "#16213A" : "#EAF3FB",
                borderRadius: 2,
                border: darkMode ? "1px solid #24304A" : "1px solid #D8E1E8",
                cursor: "pointer",
                textAlign: "center",
              }}
            >
              <Typography
                variant="h6"
                sx={{ fontFamily: "monospace", letterSpacing: 1, color: darkMode ? "#EAF3FB" : "#0E1B2C" }}
              >
                {offlineKeyDialog.key}
              </Typography>
              <Typography variant="caption" sx={{ color: copiedField === "offline-key" ? "success.main" : "text.secondary" }}>
                {copiedField === "offline-key" ? "Copied!" : "Click to copy"}
              </Typography>
            </Box>
            <Typography variant="caption" sx={{ display: "block", mt: 2, color: darkMode ? "#93A2BC" : "text.secondary" }}>
              Give this key to the customer. Entering it in the app on the licensed device will generate the local license file without needing an internet connection.
            </Typography>
          </>
        )}
      </DialogContent>
      <DialogActions sx={{ p: 3, pt: 0 }}>
        <Button onClick={close} variant="contained">
          Close
        </Button>
      </DialogActions>
    </GlassDialog>
  );
}

export default OfflineKeyDialog;
